import gsap from 'gsap';
import SplitText from 'gsap/SplitText';
gsap.registerPlugin(SplitText);

export default function Splittext() {
    try {
        gsap.utils.toArray('.reveal-text').forEach((el, i) => {
            const elLines = new SplitText(el, {
                type: 'lines',
                linesClass: 'line'
            });

          gsap.utils.toArray(elLines.lines).forEach((el, i) => {
            const wrapper = document.createElement('span');
            wrapper.classList.add('masking-text');
            el.parentNode.insertBefore(wrapper, el);
            wrapper.appendChild(el);
        });
    });
    } catch (error) {}

    try {
        gsap.utils.toArray('.split-line').forEach((el, i) => {
          const elSplit = new SplitText(el, {
            type: 'lines',
            linesClass: 'line',
          });
        });
    } catch (error) {}

    try {
        gsap.utils.toArray('.split-word').forEach((el, i) => {
          const elSplit = new SplitText(el, {
            type: 'lines, words',
            linesClass: 'line',
            wordsClass: 'word'
          });
        });
    } catch (error) {}
}
